/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.amendment-history-toolbar[_ngcontent-%COMP%]{background-color:#fff;padding:25px 0 15px 10px}.amendment-history-toolbar[_ngcontent-%COMP%]   .history[_ngcontent-%COMP%]{border-left:2px solid rgba(0,0,0,.2);margin:10px}.amendment-history-toolbar[_ngcontent-%COMP%]   .amendment-by[_ngcontent-%COMP%]{color:#000;font-style:italic}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2FtZW5kbWVudC1oaXN0b3J5L2FtZW5kbWVudC1oaXN0b3J5LmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2FtZW5kbWVudC1oaXN0b3J5L2FtZW5kbWVudC1oaXN0b3J5LmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/amendment-history/amendment-history.component.scss.shim.ngstyle.ts